import { computed, reactive, ref, watch } from "vue";
import SelectedPlan from "src/composables/SelectedPlan";
import { useSessionStorage } from "vue-composable";
import { ercot_api } from "boot/axios";
import { titleCase } from 'title-case';


const { selected_plan } = SelectedPlan();

const { storage: property_type } = useSessionStorage('property_type', null)

const { storage: owns_property } = useSessionStorage('owns_property', null);

const service_location_loading = ref(false);
const { storage: service_location } = useSessionStorage('service_location', null)

const is_loading = ref(false);
const search_service_locations = async function ({ address, zip_code }) {
    try {
        is_loading.value = true;
        const { data } = await ercot_api.get(process.env.VUE_APP_ADDRESS_SERVICE_URL, {
            params: {
                address,
                zip_code
            },
            responseType: 'json'
        });
        return data.map(map_service_location);
    }
    catch (err) {
        console.log(err);
    }
    finally {
        is_loading.value = false;
    }
}

const duns_match = computed(() => {
    return !selected_plan.value || !service_location.value || selected_plan.value.tdsp.duns_number === service_location.value.duns
})

const is_residential = computed(() => {
    return !service_location.value || service_location.value?.premise_type === 'Residential'
})

const meter_requirement_match = computed(() => {
    if (service_location.value && selected_plan.value) {
        const { is_time_of_use, is_pre_pay } = selected_plan.value.product;
        if (is_time_of_use) {
            if (!['AMSR', 'AMSM'].includes(service_location.value.tdsp_ams_indicator)) {
                return false;
            }
        }
        if (is_pre_pay) {
            if (!['AMSR'].includes(service_location.value.tdsp_ams_indicator)) {
                return false;
            }
        }
    }
    return true;
})

const has_switch_hold = computed(() => {
    if (service_location.value) {
        if (service_location.value.switch_hold_indicator === 'Y') {
            return true;
        }
    }
    return false;
})


const service_location_valid = computed(() => {
    if (!service_location.value) {
        return false
    }

    if (!duns_match.value) {
        return false
    }

    if (!is_residential.value) {
        return false;
    }

    if (!meter_requirement_match.value) {
        return false;
    }

    if (has_switch_hold.value) {
        return false;
    }

    return true;
})

const get_service_location_by_key = async function ({ esiid }) {
    try {
        let { data } = await ercot_api.get(`${process.env.VUE_APP_ADDRESS_SERVICE_URL}/${esiid}`);
        return map_service_location(data);
    }
    catch (err) {
        console.log(err);
    }
}

const map_service_location = function (service_location) {
    return {
        ...service_location,
        label: `${service_location.address}, ${service_location.city} ${service_location.state} ${service_location.zip_code}`
    };
}

const clear = function () {
    property_type.value = null;
    owns_property.value = true;
}

export default () => {
    return {
        is_loading,
        search_service_locations,

        get_service_location_by_key,
        map_service_location,

        property_type,
        owns_property,

        service_location_loading,
        service_location,
        duns_match,
        is_residential,
        meter_requirement_match,
        has_switch_hold,
        service_location_valid,
        clear
    }
}
